export class MealPlannerUtils {
  static returnUpcomingMeals(mealPlan) {
    if (!mealPlan || mealPlan.length === 0) return [];

    const dayOrder = [
      "SUNDAY",
      "MONDAY",
      "TUESDAY",
      "WEDNESDAY",
      "THURSDAY",
      "FRIDAY",
      "SATURDAY",
    ];

    const mealOrder = {
      BREAKFAST: 0,
      LUNCH: 1,
      DINNER: 2,
    };

    const now = new Date();
    const currentDayIndex = now.getDay(); // 0 = Sunday
    const currentHour = now.getHours();

    // Determine current meal slot
    let currentMealSlot;
    if (currentHour < 10) currentMealSlot = 0;
    else if (currentHour < 15) currentMealSlot = 1;
    else currentMealSlot = 2;

    const currentSortKey = currentDayIndex * 3 + currentMealSlot;

    // Normalize + sort
    const sortedMeals = mealPlan
      .map((entry) => {
        const dayIndex = dayOrder.indexOf(entry.dayCode);
        const mealIndex = mealOrder[entry.mealCode];

        return {
          ...entry,
          dayIndex,
          mealIndex,
          sortKey: dayIndex * 3 + mealIndex,
        };
      })
      .sort((a, b) => a.sortKey - b.sortKey);

    // Get upcoming meals (wrap around week)
    const upcoming = [
      ...sortedMeals.filter((m) => m.sortKey >= currentSortKey),
      ...sortedMeals.filter((m) => m.sortKey < currentSortKey),
    ].slice(0, 4);

    // Format helpers
    const formatDayLabel = (dayIndex) => {
      if (dayIndex === currentDayIndex) return "Today";
      if (dayIndex === (currentDayIndex + 1) % 7) return "Tomorrow";

      const day = dayOrder[dayIndex];
      return day.charAt(0) + day.slice(1).toLowerCase();
    };

    const formatMealCode = (mealCode) =>
      mealCode.charAt(0) + mealCode.slice(1).toLowerCase();

    // Final format
    return upcoming.map((meal) => ({
      day: formatDayLabel(meal.dayIndex),
      meal: meal.mealName,
      time: formatMealCode(meal.mealCode),
      image: meal.mealName.toLowerCase(), // placeholder
    }));
  }
}
